import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_UNIFIED_TERRITORIES_LOG: TDatadogErrorLog = {
  from: 'modules/territory/common/hooks/use-get-unified-territories',
  name: 'Gets a list of territories',
  message: 'Failed to fetch list of territories',
}
